module.exports = __webpack_public_path__ + "img/wuzhou.c91700fa.jpg";